import { isEmail } from "@mittwald/flow-lib/dist/validation";
import { isIpV4, isIpV6 } from "@mittwald/flow-lib/dist/validation/ip";
import { isUrl } from "@mittwald/flow-lib/dist/validation/url";
import { formControlFactory } from "../../lib/formControlFactory";
import { InternalTextFieldView } from "./components/InternalTextFieldView";
/** Use `TextField` for text inputs inside a Form component. */
export const TextField = formControlFactory({
    component: InternalTextFieldView,
    emptyValue: "",
    propMapping: (props) => {
        const rules = {
            ...(props.rules ?? {}),
        };
        // don't allow only whitespaces per default
        // when simple required is used
        if (rules.required === true) {
            rules.validate = {
                ...rules.validate,
                required: (v) => v.trim().length !== 0,
            };
        }
        if (props.type === "email") {
            rules.validate = {
                email: (value) => value === undefined || value.trim().length === 0
                    ? true
                    : isEmail(value),
                ...rules.validate,
            };
        }
        if (props.type === "url") {
            rules.validate = {
                url: isUrl,
                ...rules.validate,
            };
        }
        if (props.type === "ipV4") {
            rules.validate = {
                ip: isIpV4,
                ...rules.validate,
            };
        }
        if (props.type === "ipV6") {
            rules.validate = {
                ip: isIpV6,
                ...rules.validate,
            };
        }
        return { ...props, rules };
    },
});
TextField.displayName = "TextField";
export default TextField;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dEZpZWxkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVGV4dEZpZWxkL1RleHRGaWVsZC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLG9DQUFvQyxDQUFDO0FBQzdELE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLE1BQU0sdUNBQXVDLENBQUM7QUFDdkUsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLHdDQUF3QyxDQUFDO0FBQy9ELE9BQU8sRUFBRSxrQkFBa0IsRUFBRSxNQUFNLDhCQUE4QixDQUFDO0FBQ2xFLE9BQU8sRUFBRSxxQkFBcUIsRUFBRSxNQUFNLG9DQUFvQyxDQUFDO0FBRTNFLCtEQUErRDtBQUMvRCxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQUcsa0JBQWtCLENBQUM7SUFDMUMsU0FBUyxFQUFFLHFCQUFxQjtJQUNoQyxVQUFVLEVBQUUsRUFBRTtJQUNkLFdBQVcsRUFBRSxDQUFDLEtBQUssRUFBRSxFQUFFO1FBQ3JCLE1BQU0sS0FBSyxHQUFHO1lBQ1osR0FBRyxDQUFDLEtBQUssQ0FBQyxLQUFLLElBQUksRUFBRSxDQUFDO1NBQ3ZCLENBQUM7UUFFRiwyQ0FBMkM7UUFDM0MsK0JBQStCO1FBQy9CLElBQUksS0FBSyxDQUFDLFFBQVEsS0FBSyxJQUFJLEVBQUUsQ0FBQztZQUM1QixLQUFLLENBQUMsUUFBUSxHQUFHO2dCQUNmLEdBQUcsS0FBSyxDQUFDLFFBQVE7Z0JBQ2pCLFFBQVEsRUFBRSxDQUFDLENBQU0sRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksRUFBRSxDQUFDLE1BQU0sS0FBSyxDQUFDO2FBQzVDLENBQUM7UUFDSixDQUFDO1FBRUQsSUFBSSxLQUFLLENBQUMsSUFBSSxLQUFLLE9BQU8sRUFBRSxDQUFDO1lBQzNCLEtBQUssQ0FBQyxRQUFRLEdBQUc7Z0JBQ2YsS0FBSyxFQUFFLENBQUMsS0FBSyxFQUFFLEVBQUUsQ0FDZixLQUFLLEtBQUssU0FBUyxJQUFJLEtBQUssQ0FBQyxJQUFJLEVBQUUsQ0FBQyxNQUFNLEtBQUssQ0FBQztvQkFDOUMsQ0FBQyxDQUFDLElBQUk7b0JBQ04sQ0FBQyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUM7Z0JBQ3BCLEdBQUcsS0FBSyxDQUFDLFFBQVE7YUFDbEIsQ0FBQztRQUNKLENBQUM7UUFDRCxJQUFJLEtBQUssQ0FBQyxJQUFJLEtBQUssS0FBSyxFQUFFLENBQUM7WUFDekIsS0FBSyxDQUFDLFFBQVEsR0FBRztnQkFDZixHQUFHLEVBQUUsS0FBSztnQkFDVixHQUFHLEtBQUssQ0FBQyxRQUFRO2FBQ2xCLENBQUM7UUFDSixDQUFDO1FBRUQsSUFBSSxLQUFLLENBQUMsSUFBSSxLQUFLLE1BQU0sRUFBRSxDQUFDO1lBQzFCLEtBQUssQ0FBQyxRQUFRLEdBQUc7Z0JBQ2YsRUFBRSxFQUFFLE1BQU07Z0JBQ1YsR0FBRyxLQUFLLENBQUMsUUFBUTthQUNsQixDQUFDO1FBQ0osQ0FBQztRQUVELElBQUksS0FBSyxDQUFDLElBQUksS0FBSyxNQUFNLEVBQUUsQ0FBQztZQUMxQixLQUFLLENBQUMsUUFBUSxHQUFHO2dCQUNmLEVBQUUsRUFBRSxNQUFNO2dCQUNWLEdBQUcsS0FBSyxDQUFDLFFBQVE7YUFDbEIsQ0FBQztRQUNKLENBQUM7UUFFRCxPQUFPLEVBQUUsR0FBRyxLQUFLLEVBQUUsS0FBSyxFQUFFLENBQUM7SUFDN0IsQ0FBQztDQUNGLENBQUMsQ0FBQztBQUVILFNBQVMsQ0FBQyxXQUFXLEdBQUcsV0FBVyxDQUFDO0FBRXBDLGVBQWUsU0FBUyxDQUFDIn0=